import i18n from 'i18next';

export const getFeedbackTextValues = () => ({
  unclearAnswer: i18n.t(
    'GSP.pages.parentHelper.chat.body.feedbackDislikeDialog.unclearAnswer',
  ),
  incorrectInformation: i18n.t(
    'GSP.pages.parentHelper.chat.body.feedbackDislikeDialog.incorrectInformation',
  ),
  notHelpful: i18n.t(
    'GSP.pages.parentHelper.chat.body.feedbackDislikeDialog.notHelpful',
  ),
  other: i18n.t('GSP.pages.parentHelper.chat.body.feedbackDislikeDialog.other'),
});
